import fetchSearchResults from './fetchSearchResults';
import handlePagination from './handlePagination';
import transformSearchResults from './transformSearchResults';

import handleToggleByIndex from '../common/handleToggleByIndex';
import handleEventMap from '../common/handleEventMap';

/**
 * Returns a callback that handles a search request.
 * @param {Element} component
 * @param {Object} typeTemplates
 * @returns {Function}
 */
const handleSearch = (component, typeTemplates) => async (e) => {
    // check if this search component contains a result container
    const shouldRequestData = Boolean($(component).find('.search__results').length);
    // if not then we expect this to be the search dropdown
    // and submit the request to the search page.
    if (!shouldRequestData) return;

    if (e) {
        e.preventDefault();
    }

    const query = $(component).find('.search__input').val();
    // skip search handler if query did not change from previous search
    if (query === $(component).data('lastQuery')) return;

    // set loading flag
    $(component).attr('data-loading', true);
    // cache current search query
    $(component).data('lastQuery', query);

    const url = $(component).attr('data-search-url');
    const method = $(component).attr('data-search-method');
    const param = $(component).attr('data-search-query-param');
    const $initialResults = $('#initial-search-results');
    const results = $initialResults.length
        ? $initialResults.get(0)
        : await fetchSearchResults(url, method, { [param]: query });

    // transform search result markup to object
    const entries = $(results).find('[data-type]').get();
    if (process.env.NODE_ENV === 'development') {
        while (entries.length < 100) entries.push(...entries);
    }
    // store results
    const resultsByType = transformSearchResults(entries);
    $(component).data('resultsByType', resultsByType);

    // Init Tab index with unreachable Value
    let firstResultTab = -1;

    // update DOM
    Object.entries(resultsByType).forEach(([type, items], index) => {
        // apply result count for each type
        $(component).find(`span[data-${type}-count]`).text(items.length);
        // Set Tab Index to first Categorie with Results or leave it
        if (firstResultTab === -1 && items.length !== undefined && items.length > 0) {
            firstResultTab = index;
        }
        // reset pagination index for each type
        const $results = $(component).find(`[data-${type}-results]`);
        $results.attr('data-index', 0);
        // clear results content
        $results.empty();
    });

    // Set Categorie Tab to first with Results
    if (firstResultTab !== -1) {
        const $tabItems = $(component).find('.tabs__item');
        const $contents = $(component).find('.tabs__content');
        handleToggleByIndex($tabItems, firstResultTab)();
        handleToggleByIndex($contents, firstResultTab)();
        handleEventMap(component, 'tabs:select', () => firstResultTab);
    }

    // trigger pagination to render initial results
    await handlePagination(component, typeTemplates)();

    // unset loading flag
    $(component).attr('data-loading', false);

    // clear initial result
    if ($initialResults.length) $initialResults.remove();
};

export default handleSearch;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleSearch.js